import { gql } from '@apollo/client'

const EMAIL_CAMPAIGN_PROVIDER_FIELDS = gql`
  fragment EmailCampaignProviderFields on EmailCampaignProvider {
    providerId
    providerNpi
    providerName
    email
    status
    gmailThreadId
    sentAt
    repliedAt
    replyBody
    error
  }
`

const EMAIL_CAMPAIGN_FIELDS = gql`
  ${EMAIL_CAMPAIGN_PROVIDER_FIELDS}
  fragment EmailCampaignFields on EmailCampaign {
    id
    clientId
    name
    subject
    body
    status
    providers {
      ...EmailCampaignProviderFields
    }
    sentCount
    repliedCount
    failedCount
    aiReview {
      overallSeverity
      legalIssues {
        category
        description
        severity
      }
      marketingIssues {
        category
        description
        severity
      }
      suggestions
    }
    createdAt
    updatedAt
    sentAt
  }
`

export const GET_EMAIL_CAMPAIGNS = gql`
  ${EMAIL_CAMPAIGN_FIELDS}
  query GetEmailCampaigns($clientId: ID!) {
    emailCampaigns(clientId: $clientId) {
      ...EmailCampaignFields
    }
  }
`

export const GET_EMAIL_CAMPAIGN = gql`
  ${EMAIL_CAMPAIGN_FIELDS}
  query GetEmailCampaign($clientId: ID!, $campaignId: ID!) {
    emailCampaign(clientId: $clientId, campaignId: $campaignId) {
      ...EmailCampaignFields
    }
  }
`

export const GET_GMAIL_QUOTA = gql`
  query GetGmailQuota($clientId: ID!) {
    gmailQuota(clientId: $clientId) {
      sentCount
      dailyLimit
      canSend
      warningMessage
    }
  }
`

export const CREATE_EMAIL_CAMPAIGN = gql`
  ${EMAIL_CAMPAIGN_FIELDS}
  mutation CreateEmailCampaign($clientId: ID!, $input: CreateEmailCampaignInput!) {
    createEmailCampaign(clientId: $clientId, input: $input) {
      ...EmailCampaignFields
    }
  }
`

export const DELETE_EMAIL_CAMPAIGN = gql`
  mutation DeleteEmailCampaign($clientId: ID!, $campaignId: ID!) {
    deleteEmailCampaign(clientId: $clientId, campaignId: $campaignId)
  }
`

export const REVIEW_BULK_EMAIL = gql`
  mutation ReviewBulkEmail($clientId: ID!, $campaignId: ID!) {
    reviewBulkEmail(clientId: $clientId, campaignId: $campaignId) {
      overallSeverity
      legalIssues {
        category
        description
        severity
      }
      marketingIssues {
        category
        description
        severity
      }
      suggestions
    }
  }
`

export const CHECK_CAMPAIGN_REPLIES = gql`
  ${EMAIL_CAMPAIGN_FIELDS}
  mutation CheckCampaignReplies($clientId: ID!, $campaignId: ID!) {
    checkCampaignReplies(clientId: $clientId, campaignId: $campaignId) {
      ...EmailCampaignFields
    }
  }
`

export const UPDATE_EMAIL_CAMPAIGN = gql`
  mutation UpdateEmailCampaign($clientId: ID!, $campaignId: ID!, $patch: UpdateEmailCampaignInput!) {
    updateEmailCampaign(clientId: $clientId, campaignId: $campaignId, patch: $patch) {
      id
      name
      subject
      body
      status
      updatedAt
    }
  }
`

export const MARK_CAMPAIGN_PROVIDER_FOLLOWUP = gql`
  ${EMAIL_CAMPAIGN_FIELDS}
  mutation MarkCampaignProviderFollowup(
    $clientId: ID!
    $campaignId: ID!
    $providerNpi: String!
    $needsFollowup: Boolean!
  ) {
    markCampaignProviderFollowup(
      clientId: $clientId
      campaignId: $campaignId
      providerNpi: $providerNpi
      needsFollowup: $needsFollowup
    ) {
      ...EmailCampaignFields
    }
  }
`
